import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ChatMessage, ChatThread, MessagesResponse } from '../../models/chat.model';

interface ApiResponse<T> { success: boolean; data?: T; error?: string; }

@Injectable({ providedIn: 'root' })
export class ChatService {
  private readonly http = inject(HttpClient);

  /** ดึง threads — context='bidder' บังคับ bidder mode (สำหรับ floating-chat) */
  getMyThreads(context?: 'bidder'): Observable<ChatThread[]> {
    const url = context ? `/api/chat/threads?context=${context}` : '/api/chat/threads';
    return this.http.get<ApiResponse<ChatThread[]>>(url).pipe(
      map(r => r.data ?? []),
    );
  }

  getMessages(threadId: string): Observable<MessagesResponse> {
    return this.http.get<ApiResponse<MessagesResponse>>(`/api/chat/threads/${threadId}/messages`).pipe(
      map(r => r.data ?? { messages: [], peer_read_info: { last_read_at: null, avatar_url: null, display_name: null } }),
    );
  }

  sendMessage(threadId: string, message: string): Observable<ChatMessage> {
    return this.http.post<ApiResponse<ChatMessage>>(`/api/chat/threads/${threadId}/messages`, { message }).pipe(
      map(r => r.data!),
    );
  }
}
